// Function to get today's date and format it for use in the mock data
const formatDate = (daysFromNow = 0, hour = 10, minute = 0) => {
  const date = new Date()
  date.setDate(date.getDate() + daysFromNow)
  date.setHours(hour, minute, 0, 0)
  return date.toISOString()
}

export const surgeryListMockData = [
  // Today's surgeries
  {
    surgeryId: 'SUR-001',
    patientName: 'Laura Martinez',
    patientId: 'PT-1563',
    surgeryType: 'Hernia Repair',
    scheduledDateTime: formatDate(0, 10, 30), // Today at 10:30 AM
    duration: 60,
    assignedSurgeon: 'Dr. Sarah Johnson',
    anaesthesiologist: 'Dr. Daniel Wright',
    surgicalAssistant: 'Dr. Michael Harris',
    nurses: ['Nurse Emily Clark', 'Nurse Jason Rodriguez'],
    surgeryRoom: 'Operating Room 1',
    preparationNotes: 'Patient has latex allergy, use latex-free products',
    preOpStatus: 'Ready',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, vitals stable',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Mesh'],
    estimatedBloodLoss: '50-100mL',
    procedureCode: 'CPT 49505'
  },
  {
    surgeryId: 'SUR-002',
    patientName: 'William Davis',
    patientId: 'PT-1587',
    surgeryType: 'Knee Arthroscopy',
    scheduledDateTime: formatDate(0, 12, 0), // Today at 12:00 PM
    duration: 90,
    assignedSurgeon: 'Dr. James Wilson',
    anaesthesiologist: 'Dr. Emma Taylor',
    surgicalAssistant: 'Dr. Rachel Brown',
    nurses: ['Nurse Thomas White', 'Nurse Catherine Lee'],
    surgeryRoom: 'Operating Room 2',
    preparationNotes: 'Previous knee surgery 2 years ago, review prior surgical notes',
    preOpStatus: 'Ready',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, vitals stable',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Arthroscopic tower', 'Shaver'],
    estimatedBloodLoss: '25-50mL',
    procedureCode: 'CPT 29881'
  },
  {
    surgeryId: 'SUR-003',
    patientName: 'Jennifer Wilson',
    patientId: 'PT-1502',
    surgeryType: 'Laparoscopic Cholecystectomy',
    scheduledDateTime: formatDate(0, 14, 30), // Today at 2:30 PM
    duration: 120,
    assignedSurgeon: 'Dr. Robert Chen',
    anaesthesiologist: 'Dr. Amanda Parker',
    surgicalAssistant: 'Dr. Michael Harris',
    nurses: ['Nurse Amanda Rodriguez', 'Nurse David Wong'],
    surgeryRoom: 'Operating Room 3',
    preparationNotes: 'History of GERD, elevated BMI',
    preOpStatus: 'Prep Delay',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, vitals stable',
    consentStatus: 'Signed',
    labResults: 'Slightly elevated liver enzymes, cleared by anesthesia',
    specialEquipment: ['Laparoscopic tower', 'Harmonic scalpel'],
    estimatedBloodLoss: '50-100mL',
    procedureCode: 'CPT 47562'
  },

  // Tomorrow's surgeries
  {
    surgeryId: 'SUR-004',
    patientName: 'Charles Miller',
    patientId: 'PT-1612',
    surgeryType: 'Pacemaker Insertion',
    scheduledDateTime: formatDate(1, 9, 0), // Tomorrow at 9:00 AM
    duration: 120,
    assignedSurgeon: 'Dr. Maria Garcia',
    anaesthesiologist: 'Dr. John Peterson',
    surgicalAssistant: 'Dr. Robert Chen',
    nurses: ['Nurse Sarah Collins', 'Nurse Michael Chen'],
    surgeryRoom: 'Operating Room 4',
    preparationNotes: 'Patient on anticoagulation therapy, discontinued 5 days ago',
    preOpStatus: 'Ready',
    urgency: 'Urgent',
    patientStatus: 'NPO since midnight, cardiac monitoring in place',
    consentStatus: 'Signed',
    labResults: 'INR 1.2, within acceptable range for procedure',
    specialEquipment: ['Fluoroscopy', 'Pacemaker device - Medtronic Advisa MRI'],
    estimatedBloodLoss: '25-50mL',
    procedureCode: 'CPT 33208'
  },
  {
    surgeryId: 'SUR-005',
    patientName: 'Susan Johnson',
    patientId: 'PT-1534',
    surgeryType: 'Mastectomy',
    scheduledDateTime: formatDate(1, 11, 0), // Tomorrow at 11:00 AM
    duration: 180,
    assignedSurgeon: 'Dr. Jessica Adams',
    anaesthesiologist: 'Dr. Michelle Rodriguez',
    surgicalAssistant: 'Dr. Lisa Thompson',
    nurses: ['Nurse Jennifer Lopez', 'Nurse David Chen'],
    surgeryRoom: 'Operating Room 5',
    preparationNotes: 'Patient opted for immediate reconstruction, plastic surgery team on standby',
    preOpStatus: 'Ready',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, vitals stable, emotional support provided',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Tissue expander'],
    estimatedBloodLoss: '100-200mL',
    procedureCode: 'CPT 19303'
  },
  {
    surgeryId: 'SUR-006',
    patientName: 'Barbara Wilson',
    patientId: 'PT-1567',
    surgeryType: 'Angioplasty',
    scheduledDateTime: formatDate(1, 14, 0), // Tomorrow at 2:00 PM
    duration: 120,
    assignedSurgeon: 'Dr. David Lee',
    anaesthesiologist: 'Dr. Amanda Parker',
    surgicalAssistant: null,
    nurses: ['Nurse Jennifer Lopez', 'Nurse Richard Taylor'],
    surgeryRoom: 'Cath Lab 1',
    preparationNotes: 'History of previous MI, currently stable',
    preOpStatus: 'Ready',
    urgency: 'Urgent',
    patientStatus: 'NPO since midnight, vitals stable',
    consentStatus: 'Signed',
    labResults: 'Cardiac enzymes normal, renal function adequate for contrast',
    specialEquipment: ['Angiography suite', 'Stents - Drug-eluting'],
    estimatedBloodLoss: 'Minimal',
    procedureCode: 'CPT 92920'
  },
  {
    surgeryId: 'SUR-012',
    patientName: 'Robert Thompson',
    patientId: 'PT-1678',
    surgeryType: 'Robotic Prostatectomy',
    scheduledDateTime: formatDate(1, 16, 30), // Tomorrow at 4:30 PM
    duration: 240,
    assignedSurgeon: 'Dr. Michael Williams',
    anaesthesiologist: 'Dr. Emma Taylor',
    surgicalAssistant: 'Dr. Rachel Brown',
    nurses: ['Nurse Thomas White', 'Nurse Amanda Rodriguez'],
    surgeryRoom: 'Operating Room 7',
    preparationNotes: 'Using da Vinci surgical system, pre-op nerve mapping completed',
    preOpStatus: 'Ready',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, pre-op bowel prep completed',
    consentStatus: 'Signed',
    labResults: 'PSA elevated, other labs within normal limits',
    specialEquipment: ['da Vinci Robot', 'Nerve monitoring system'],
    estimatedBloodLoss: '100-200mL',
    procedureCode: 'CPT 55866'
  },

  // Upcoming surgeries (next few days)
  {
    surgeryId: 'SUR-007',
    patientName: 'Nancy Clark',
    patientId: 'PT-1601',
    surgeryType: 'Upper Endoscopy',
    scheduledDateTime: formatDate(2, 10, 0), // 2 days from now at 10:00 AM
    duration: 45,
    assignedSurgeon: 'Dr. Thomas Baker',
    anaesthesiologist: 'Dr. Michelle Rodriguez',
    surgicalAssistant: null,
    nurses: ['Nurse Amanda Rodriguez'],
    surgeryRoom: 'Endoscopy Suite 1',
    preparationNotes: 'Investigating persistent GERD symptoms, potential biopsy',
    preOpStatus: 'Ready',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, vitals stable',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Endoscopy tower', 'Biopsy forceps'],
    estimatedBloodLoss: 'Minimal',
    procedureCode: 'CPT 43235'
  },
  {
    surgeryId: 'SUR-008',
    patientName: 'Thomas Wilson',
    patientId: 'PT-1545',
    surgeryType: 'Laminectomy',
    scheduledDateTime: formatDate(3, 13, 30), // 3 days from now at 1:30 PM
    duration: 180,
    assignedSurgeon: 'Dr. Michael Williams',
    anaesthesiologist: 'Dr. Christopher Lee',
    surgicalAssistant: 'Dr. Jessica Adams',
    nurses: ['Nurse David Chen', 'Nurse Laura Martinez'],
    surgeryRoom: 'Operating Room 6',
    preparationNotes: 'MRI shows L4-L5 stenosis, neurological symptoms',
    preOpStatus: 'Ready',
    urgency: 'Elective',
    patientStatus: 'NPO since midnight, vitals stable',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Surgical microscope', 'Neuromonitoring equipment'],
    estimatedBloodLoss: '100-200mL',
    procedureCode: 'CPT 63047'
  },
  {
    surgeryId: 'SUR-009',
    patientName: 'Richard Brown',
    patientId: 'PT-1623',
    surgeryType: 'Appendectomy',
    scheduledDateTime: formatDate(0, 17, 0), // Today at 5:00 PM (emergency case)
    duration: 60,
    assignedSurgeon: 'Dr. Sarah Johnson',
    anaesthesiologist: 'Dr. Daniel Wright',
    surgicalAssistant: 'Dr. Michael Harris',
    nurses: ['Nurse Emily Clark', 'Nurse Jason Rodriguez'],
    surgeryRoom: 'Operating Room 1',
    preparationNotes: 'Acute appendicitis, antibiotics started',
    preOpStatus: 'Pending',
    urgency: 'Emergency',
    patientStatus: 'NPO, IV fluids running, pain managed',
    consentStatus: 'Signed',
    labResults: 'Elevated WBC, CT confirmed appendicitis',
    specialEquipment: ['Laparoscopic tower'],
    estimatedBloodLoss: '50-100mL',
    procedureCode: 'CPT 44970'
  },
  {
    surgeryId: 'SUR-010',
    patientName: 'Margaret Davis',
    patientId: 'PT-1645',
    surgeryType: 'Total Knee Replacement',
    scheduledDateTime: formatDate(4, 8, 0), // 4 days from now at 8:00 AM
    duration: 180,
    assignedSurgeon: 'Dr. James Wilson',
    anaesthesiologist: 'Dr. Emma Taylor',
    surgicalAssistant: 'Dr. Rachel Brown',
    nurses: ['Nurse Thomas White', 'Nurse Catherine Lee'],
    surgeryRoom: 'Operating Room 2',
    preparationNotes: 'Patient prepped for regional anesthesia, blood typed and cross-matched',
    preOpStatus: 'Scheduled',
    urgency: 'Elective',
    patientStatus: 'Pre-admission workup completed',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Knee prosthesis - Smith & Nephew Genesis II', 'Tourniquet'],
    estimatedBloodLoss: '300-500mL',
    procedureCode: 'CPT 27447'
  },
  // Additional upcoming surgeries
  {
    surgeryId: 'SUR-011',
    patientName: 'Elizabeth Roberts',
    patientId: 'PT-1589',
    surgeryType: 'Hip Arthroplasty',
    scheduledDateTime: formatDate(5, 10, 30), // 5 days from now at 10:30 AM
    duration: 180,
    assignedSurgeon: 'Dr. James Wilson',
    anaesthesiologist: 'Dr. Emma Taylor',
    surgicalAssistant: 'Dr. Rachel Brown',
    nurses: ['Nurse Thomas White', 'Nurse Catherine Lee'],
    surgeryRoom: 'Operating Room 2',
    preparationNotes: 'Patient requires extended recovery monitoring due to age',
    preOpStatus: 'Scheduled',
    urgency: 'Elective',
    patientStatus: 'Pre-admission workup completed',
    consentStatus: 'Signed',
    labResults: 'All within normal limits',
    specialEquipment: ['Hip prosthesis', 'Surgical navigation system'],
    estimatedBloodLoss: '300-500mL',
    procedureCode: 'CPT 27130'
  }
]
